export const TOTAL_WIZARD_STEPS = 10;

export const WIZARD_STEP_KEYS = [
  'wizard.steps.language',
  'wizard.steps.country',
  'wizard.steps.personal',
  'wizard.steps.education',
  'wizard.steps.experience',
  'wizard.steps.languageSkills',
  'wizard.steps.cvUpload',
  'wizard.steps.financial',
  'wizard.steps.review',
  'wizard.steps.submit'
];

export const WIZARD_STEP_FALLBACK_LABELS = [
  'Language',
  'Country',
  'Personal',
  'Education',
  'Experience',
  'Language Skills',
  'CV Upload',
  'Financial',
  'Review',
  'Submit'
];
